import { render, staticRenderFns } from "./Why.vue?vue&type=template&id=7071fcc6&scoped=true&"
import script from "./Why.vue?vue&type=script&lang=js&"
export * from "./Why.vue?vue&type=script&lang=js&"
import style0 from "./Why.vue?vue&type=style&index=0&id=7071fcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7071fcc6",
  null
  
)

component.options.__file = "Why.vue"
export default component.exports